import { FlowStepEditor } from "../FlowStepEditor";
import React from "react";
import { MappingStep } from "../../../rule-engine-core/Flow/Steps/UI/MappingStep"; // import { StyledButton } from "../../../CommonUI/Components/Button";
import { StyledButton } from "../../../CommonUI/BuildlingBlocks/StyledButton";
import { UILayer } from "../../../CommonUI/BuildlingBlocks/UILayer";
import { MappingBuilder } from "../../../Mapping/MappingBuilder";
import { StateManager } from "../../../rule-engine-core/Common/StateManager";
import { UIStyleConstants } from "../../../rule-engine-core/Common/UIStyleConstants";

const StepEditUI = ({ step }: { step: MappingStep }) => {
    const [open, setOpen] = React.useState<boolean>(false);

    return (
        <>
            <StyledButton
                sx={{ background: UIStyleConstants.BLUE_COLOR }}
                variant="contained"
                onClick={() => setOpen(true)}
            >
                Edit {step.name || "Rule Step"}
            </StyledButton>

            <UILayer
                open={open}
                fullScreen
                padding="0px 0px"
                renderUI={() => (
                    <MappingBuilder
                        definition={step.executable}
                        mappingBuilderName={step.executable.title || step.name}
                        onSave={() => {
                            setOpen(false);
                        }}
                        onCancel={() => {
                            StateManager.changed(step);
                            setOpen(false);
                        }}
                    />
                )}
                onClose={() => setOpen(false)}
            />
        </>
    );
};

export class MappingStepEditor extends FlowStepEditor<MappingStep> {
    renderEditUI(): JSX.Element | null {
        return <StepEditUI step={this.stepData} />;
    }
}
